'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /* eslint-disable arrow-body-style */


var _step2Functions = require('../../helpers/step2Functions');

exports.default = function (values) {
  return _extends({
    applicant: values.applicant.map(function (applicant, i) {
      return _extends({}, (0, _step2Functions.validateApplicants)(applicant, values, i));
    })
  }, (0, _step2Functions.validateCardDetails)(values));
};


//////////////////
// WEBPACK FOOTER
// ./src/v2/validators/tugo/Applicants.js
// module id = 1786
// module chunks = 0